import React,{useState, forwardRef, useImperativeHandle, useEffect, useRef} from 'react';
import RCIDatePicker from './RCIDatePicker';
import {ScreenType}  from "../../utils/detectScreen";
import {useSelector} from 'react-redux';
import {getTranslatedMsg} from "../../utils/favoriteMCTranslatedmsg";
import FlexPanel from './flexPanel';
const RCIDatePickerContainer = (props)=> {
    //debugger;
    	const custlocale=useSelector(state=>state.CommonReducer.locale);
		const msg_data = useSelector(state=> state.FavMsgCatReducer.msg_cat_data);
    const getCalDurationEnd=()=>{
        
        let date = new Date(); 
        date.setFullYear(date.getFullYear() + 2);
        return date;
    }
    
    //debugger;
    const fromMonth= props.StartDate!== undefined ? props.StartDate : new Date();
    const clearDateRef = useRef();
    //const toMonth=getCalDurationEnd();
    const toMonth=props.toMonth;
    const [highLightCalFeild, sethighLightCalFeild]=useState({fromHasBgcolor:true,toHasBgColor:false})
    
    const [stateCalendar, setstateCalendar] = useState({calfrom:undefined,calto:undefined})
    useEffect(() => {
    }, [highLightCalFeild])
    const calDayBtnClickevent=(from,to,modifiers)=>{
        props.calCheckinDayBtnFn && props.calCheckinDayBtnFn(from,to,modifiers)
       setstateCalendar({calfrom:from,calto:to});
       //debugger;
       if(from && to){
        sethighLightCalFeild({fromHasBgcolor:true,toHasBgColor:false})
       }else if(from){
        sethighLightCalFeild({fromHasBgcolor:false,toHasBgColor:true})
       }
    }
    const HideDatePicker=()=>{
        props.toggleDatePickerhide();
    }
    
    const resetcalFeild=(checkInClear,CheckOutClear)=>{
       // debugger;
        
        
        
            props.clearDates && props.clearDates();
            setstateCalendar({calfrom:undefined,calto:undefined});
            sethighLightCalFeild({fromHasBgcolor:true,toHasBgColor:false});
        
        /* if(checkInClear){
            console.log(clearDateRef.current)
            setstateCalendar({calfrom:undefined})
            sethighLightCalFeild({fromHasBgcolor:true,toHasBgColor:false});
            //document.getElementsByClassName("DayPicker-Day")[0].classList().remove("DayPicker-Day--start DayPicker-Day--selected")
        }
        else if(CheckOutClear){
            setstateCalendar({calto:undefined}) ;
            sethighLightCalFeild({fromHasBgcolor:false,toHasBgColor:true});
        }
        else{
            props.clearDates && props.clearDates();
            setstateCalendar({calfrom:undefined,calto:undefined});
            sethighLightCalFeild({fromHasBgcolor:true,toHasBgColor:false});
        } */
        
    }
  /*   useImperativeHandle(
        ref,
        () => ({
            resetcalFeild
        }),
    ) */
    //debugger;
    //props.ref.current = resetcalFeild;
    const applyBtnClickFn=(from,to)=>{
         props.applyBtnfn(from,to);
    }
    // const formateDate=(dateloc,datetoFormate)=>{
	// 	let d = new Date(datetoFormate);
	// 	let opt = {  year: 'numeric', month: 'short', day: 'numeric' };
	// 	return d.toLocaleDateString(dateloc, opt);
	// }
    return (
        <FlexPanel 
        containerId={props.id}
        title={`${props.calmonths === 1 ? getTranslatedMsg(29,msg_data,custlocale,'RCI_React_Favorites_Points','check-in Date'): getTranslatedMsg(12,msg_data,custlocale,'RCI_React_Favorites_Points','Check-in Date Range')}`} 
        type={"auto"} 
        position={"position-relative"} 
        visible={true} closeBtnFn={HideDatePicker}
        calenderHeadingFlag = {props.calenderHeading}
        closeBtnFlag = {props.closeBtn}
        >
            <div className="calendar-container">
                    <div className={`calendar-selections ${props.showdatePickerlables ? '' : 'd-none'} `}>
                        {props.calmonths == 1 && <span className={`calender-select ${highLightCalFeild.fromHasBgcolor ? 'active' : ''}`}>  {stateCalendar.calfrom ? stateCalendar.calfrom.toLocaleDateString(props.localCal, {
                            day: '2-digit', month: 'short', year: 'numeric'
                        }).replace(/ /g, ' ') : getTranslatedMsg(30,msg_data,custlocale,'RCI_React_Favorites_Points','Select Date')}     </span>}

                        {props.calmonths > 1 && <> <span className={`calender-select ${highLightCalFeild.fromHasBgcolor ? 'active' : ''}`}>  {stateCalendar.calfrom ? stateCalendar.calfrom.toLocaleDateString(props.localCal, {
                            day: '2-digit', month: 'short', year: 'numeric'
                        }).replace(/ /g, ' ') : getTranslatedMsg(13,msg_data,custlocale,'RCI_React_Favorites_Points','Check-in Date Range From')} </span>
                              <span className="calendar-dash"> - </span>
                            <span className={`calender-select   ${highLightCalFeild.toHasBgColor ? 'active' : ''}`}> {stateCalendar.calto ? stateCalendar.calto.toLocaleDateString(props.localCal, {
                                day: '2-digit', month: 'short', year: 'numeric'
                            }).replace(/ /g, ' ') : getTranslatedMsg(14,msg_data,custlocale,'RCI_React_Favorites_Points','Check-in Date Range To')} </span> </>}
                    </div>
                    
                    <RCIDatePicker resetCalfeilds={resetcalFeild} 
                    DatePickerLocal={props.localCal} 
                    deviceType={ScreenType()} 
                    monthsToDisplay={props.calmonths} 
                    applyBtnClickFn={applyBtnClickFn} 
                    calDayBtnClickFn={calDayBtnClickevent} 
                    fromMonth={fromMonth} 
                    toMonth={toMonth}
                    $highlightBothSelectedDays={props.highlightBothSelectedDays}
                    $showSelctedCheckinDays = {props.showSelctedCheckinDays ? props.showSelctedCheckinDays:""}
                    $containerId={props.id}
                    $ipadLandscape = {props.isIpadLandscape}
                    $defaultDate = {props.defaultDate}
                    ></RCIDatePicker>
            </div>
        </FlexPanel>
    )

}

export default RCIDatePickerContainer;